import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { DatePicker, Select, Spin } from 'antd'
import { commissions, users } from '../../../../../services/api'
import { alertPopup } from '@utils/popup'
import moment from 'moment'

@inject((store: any) => {
    const { authStore } = store

    return {
        authStore
    }
})
@observer
export class CommissionRatesEdit extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            editRates: false,
            editMonths: false,
            advanced_commission: '',
            older_than: {},
            loadingMonth: false,
            loadingRates: false
        }
    }

    componentDidMount(): void {
        const { advanced_commission } = this.props.agentInfo
        this.setState({ advanced_commission })
    }

    formatCommission = decimal => {
        return `${(decimal * 100).toFixed(2)}%`
    }

    saveRateChanges = e => {
        e.preventDefault()

        const { agentInfo } = this.props
        let rates = JSON.parse(agentInfo.percents)

        for (let el in e.target.elements) {
            let target = e.target.elements[el]

            if (target.id && target.nodeName === 'INPUT') {
                let [product, type, rate] = target.id.split('-')
                let value = Number(target.value)

                if (typeof value === 'number' && value <= 100 && value >= 0) {
                    rates[product][type][rate] = (value / 100).toFixed(3)
                }
            }
        }

        Object.keys(this.state.older_than).forEach(product => {
            if (this.state.older_than[product])
                rates[product].older_than = this.state.older_than[product].format('YYYY-MM-DD')
        })

        this.setState({ loadingRates: true }, () => {
            commissions
                .updateCommissionPercents({ agentId: agentInfo.id, percents: rates })
                .then(() => {
                    this.props.updateInfo()
                    this.setState({ editRates: false })
                })
                .catch(error => {
                    console.log(error.response)

                    if (error.response.data.error && error.response.data.error == 'UPDATE_COMMISSIONS_ERROR') {
                        let body = (
                            <p>
                                <h6>{'העדכון נכשל עבור העמלות הבאות:'}</h6>
                                <p>{JSON.stringify(error.response.data.ids)}</p>
                            </p>
                        )

                        alertPopup({ type: 'error', title: 'אירעה שגיאה בעת עדכון עמלות', body })
                    } else {
                        alertPopup({ type: 'error', title: 'אירעה שגיאה. העדכון לא בוצע/לא בוצע במלואו', body: '' })
                    }
                })
                .finally(() => {
                    this.setState({ loadingRates: false })
                })
        })
    }

    handleMonthSelect = advanced_commission => {
        this.setState({ advanced_commission })
    }

    submitMonth = () => {
        const { advanced_commission } = this.state
        const { id: agent_id } = this.props.agentInfo

        if (typeof advanced_commission == 'number') {
            this.setState({ loadingMonth: true }, () => {
                users
                    .updateAdvancedCommission({ advanced_commission, agent_id })
                    .then(res => {
                        return this.props.updateInfo()
                    })
                    .then(() => {
                        this.setState({ editMonths: false })
                    })
                    .catch(error => {
                        console.log('error', error.response)
                        alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
                    })
                    .finally(() => {
                        this.setState({ loadingMonth: false })
                    })
            })
        }
    }

    rateUnit = (percents, product, agentType, rate) => {
        if (percents[product][agentType].hasOwnProperty(rate)) {
            return (
                <div style={{ display: 'flex', marginLeft: '14px' }}>
                    <span style={{ marginLeft: '6px' }}>{`${this.rateTypes[rate]}:`}</span>
                    <span>{this.formatCommission(percents[product][agentType][rate])}</span>
                </div>
            )
        }
    }

    editUnit = (percents, product, agentType, rate) => {
        if (percents[product][agentType].hasOwnProperty(rate)) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '12px' }}>
                    <span style={{ marginLeft: '4px' }}>{`${this.rateTypes[rate]}:`}</span>
                    <input
                        style={{ width: '60px' }}
                        id={`${product}-${agentType}-${rate}`}
                        defaultValue={`${(percents[product][agentType][rate] * 100).toFixed(2)}`}
                    />
                </div>
            )
        }
    }

    olderThan = (percents, product, edit) => {
        let formated = percents[product].older_than ? this.formatDate(percents[product].older_than) : ''

        let momentObj = percents[product].older_than ? moment(new Date(percents[product].older_than)) : undefined
        if (percents[product].hasOwnProperty('older_than')) {
            return edit ? (
                <div>
                    <span>{'תאריך אחוז ישן: '}</span>
                    <DatePicker
                        id={`older_than-${product}`}
                        onChange={e => this.setDate(product, e)}
                        defaultValue={momentObj}
                    />
                </div>
            ) : (
                <div>
                    <span>{'תאריך אחוז ישן: '}</span>
                    <span>{formated}</span>
                </div>
            )
        }
    }

    formatDate = dateStr => {
        let date = new Date(dateStr).toLocaleDateString('he-IL')
        return date
    }

    setDate = (product, e) => {
        this.setState({ older_than: { ...this.state.older_than, [product]: e } })
    }

    rateTypes = {
        old: 'אחוז ישן',
        monthly: 'חודשי',
        advanced: 'ראשוני'
    }

    render() {
        const {
            agentInfo,
            authStore: { roles }
        } = this.props
        const { editRates, editMonths, loadingMonth, loadingRates, advanced_commission } = this.state

        const percents = JSON.parse(agentInfo.percents || '{}')

        const isSubAgent = agentInfo.parent_agency_id
        const isParentAgent = agentInfo.subAgents.length > 0
        const isFreeAgent = !isSubAgent && !isParentAgent

        return (
            <div style={{ display: 'flex' }}>
                <div>
                    <div style={style3.title}>
                        {!editRates &&
                            (roles.includes('admin') ||
                                roles.includes('moderator') ||
                                roles.includes('money') ||
                                roles.includes('agents_moderator')) && (
                                <span style={{ ...style3.pointer }} onClick={() => this.setState({ editRates: true })}>
                                    {'עריכה'}
                                </span>
                            )}
                        {editRates && (
                            <div style={{}}>
                                <span style={{ ...style3.pointer }} onClick={() => this.setState({ editRates: false })}>
                                    {'ביטול'}
                                </span>
                            </div>
                        )}
                    </div>
                    <div style={style3.body}>
                        {!editRates &&
                            Object.keys(percents).map((type, index) => {
                                if (isFreeAgent) {
                                    return (
                                        <div
                                            style={{ ...style3.unit, display: 'flex', flexDirection: 'column' }}
                                            key={index.toString()}
                                        >
                                            <span
                                                style={{ fontWeight: '500', fontSize: '16px', marginLeft: '10px' }}
                                            >{`${type}:`}</span>
                                            <div style={{ display: 'flex' }}>
                                                {percents[type].older_than
                                                    ? this.rateUnit(percents, type, 'general', 'old')
                                                    : ''}
                                                {this.rateUnit(percents, type, 'general', 'advanced')}
                                                {this.rateUnit(percents, type, 'general', 'monthly')}
                                            </div>
                                            {this.olderThan(percents, type, false)}
                                        </div>
                                    )
                                } else if (isParentAgent) {
                                    return (
                                        <div style={{ ...style3.column, ...style3.unit }} key={index.toString()}>
                                            <h6>{type}</h6>
                                            <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                <span style={{ fontWeight: '600' }}>{'עמלת מכירה אישית:'}</span>
                                                <div style={{ display: 'flex' }}>
                                                    {percents[type].older_than
                                                        ? this.rateUnit(percents, type, 'general', 'old')
                                                        : ''}
                                                    {this.rateUnit(percents, type, 'general', 'advanced')}
                                                    {this.rateUnit(percents, type, 'general', 'monthly')}
                                                </div>
                                            </div>
                                            <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                <span style={{ fontWeight: '600' }}>{'עמלה כסוכן אב:'}</span>
                                                <div style={{ display: 'flex' }}>
                                                    {percents[type].older_than
                                                        ? this.rateUnit(percents, type, 'parent', 'old')
                                                        : ''}
                                                    {this.rateUnit(percents, type, 'parent', 'advanced')}
                                                    {this.rateUnit(percents, type, 'parent', 'monthly')}
                                                </div>
                                            </div>
                                            <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                <span style={{ fontWeight: '600' }}>{'עמלת סוכני משנה:'}</span>
                                                <div style={{ display: 'flex' }}>
                                                    {percents[type].older_than
                                                        ? this.rateUnit(percents, type, 'sub', 'old')
                                                        : ''}
                                                    {this.rateUnit(percents, type, 'sub', 'advanced')}
                                                    {this.rateUnit(percents, type, 'sub', 'monthly')}
                                                </div>
                                            </div>
                                            {this.olderThan(percents, type, false)}
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div style={{ ...style3.column, ...style3.unit }} key={index.toString()}>
                                            <h6>{type}</h6>
                                            <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                <span style={{ fontWeight: '600' }}>{'עמלה אישית (סוכן משנה):'}</span>
                                                <div style={{ display: 'flex' }}>
                                                    {percents[type].older_than
                                                        ? this.rateUnit(percents, type, 'sub', 'old')
                                                        : ''}
                                                    {this.rateUnit(percents, type, 'sub', 'advanced')}
                                                    {this.rateUnit(percents, type, 'sub', 'monthly')}
                                                </div>
                                            </div>
                                            <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                <span style={{ fontWeight: '600' }}>{'עמלת סוכן אב:'}</span>
                                                <div style={{ display: 'flex' }}>
                                                    {percents[type].older_than
                                                        ? this.rateUnit(percents, type, 'parent', 'old')
                                                        : ''}
                                                    {this.rateUnit(percents, type, 'parent', 'advanced')}
                                                    {this.rateUnit(percents, type, 'parent', 'monthly')}
                                                </div>
                                            </div>
                                            {this.olderThan(percents, type, false)}
                                        </div>
                                    )
                                }
                            })}

                        {editRates && (
                            <form style={style3.form} onSubmit={this.saveRateChanges}>
                                {Object.keys(percents).map((type, index) => {
                                    if (isFreeAgent) {
                                        return (
                                            <div style={style3.formUnit} key={index.toString()}>
                                                <div style={{ ...style3.column, justifyContent: 'space-between' }}>
                                                    <span
                                                        style={{
                                                            fontWeight: '500',
                                                            fontSize: '16px',
                                                            marginLeft: '10px'
                                                        }}
                                                    >{`${type}(%):`}</span>
                                                    <div style={{ display: 'flex' }}>
                                                        {percents[type].older_than
                                                            ? this.editUnit(percents, type, 'general', 'old')
                                                            : ''}
                                                        {this.editUnit(percents, type, 'general', 'advanced')}
                                                        {this.editUnit(percents, type, 'general', 'monthly')}
                                                    </div>
                                                </div>
                                                {this.olderThan(percents, type, true)}
                                            </div>
                                        )
                                    } else if (isParentAgent) {
                                        return (
                                            <div style={style3.formUnit} key={index.toString()}>
                                                <h6>{type}</h6>
                                                <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                    <span style={{ fontWeight: '600' }}>{'עמלת מכירה אישית(%):'}</span>
                                                    <div style={{ display: 'flex' }}>
                                                        {percents[type].older_than
                                                            ? this.editUnit(percents, type, 'general', 'old')
                                                            : ''}
                                                        {this.editUnit(percents, type, 'general', 'advanced')}
                                                        {this.editUnit(percents, type, 'general', 'monthly')}
                                                    </div>
                                                </div>
                                                <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                    <span style={{ fontWeight: '600' }}>{'עמלה כסוכן אב(%):'}</span>
                                                    <div style={{ display: 'flex' }}>
                                                        {percents[type].older_than
                                                            ? this.editUnit(percents, type, 'parent', 'old')
                                                            : ''}
                                                        {this.editUnit(percents, type, 'parent', 'advanced')}
                                                        {this.editUnit(percents, type, 'parent', 'monthly')}
                                                    </div>
                                                </div>
                                                <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                    <span style={{ fontWeight: '600' }}>{'עמלת סוכני משנה(%):'}</span>
                                                    <div style={{ display: 'flex' }}>
                                                        {percents[type].older_than
                                                            ? this.editUnit(percents, type, 'sub', 'old')
                                                            : ''}
                                                        {this.editUnit(percents, type, 'sub', 'advanced')}
                                                        {this.editUnit(percents, type, 'sub', 'monthly')}
                                                    </div>
                                                </div>
                                                {this.olderThan(percents, type, true)}
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div style={style3.formUnit} key={index.toString()}>
                                                <h6>{type}</h6>
                                                <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                    <span style={{ fontWeight: '600' }}>
                                                        {'עמלה אישית (סוכן משנה)(%): '}
                                                    </span>
                                                    <div style={{ display: 'flex' }}>
                                                        {percents[type].older_than
                                                            ? this.editUnit(percents, type, 'sub', 'old')
                                                            : ''}
                                                        {this.editUnit(percents, type, 'sub', 'advanced')}
                                                        {this.editUnit(percents, type, 'sub', 'monthly')}
                                                    </div>
                                                </div>
                                                <div style={{ ...style3.column, marginBottom: '6px' }}>
                                                    <span style={{ fontWeight: '600' }}>{'עמלת סוכן אב(%): '}</span>
                                                    <div style={{ display: 'flex' }}>
                                                        {percents[type].older_than
                                                            ? this.editUnit(percents, type, 'parent', 'old')
                                                            : ''}
                                                        {this.editUnit(percents, type, 'parent', 'advanced')}
                                                        {this.editUnit(percents, type, 'parent', 'monthly')}
                                                    </div>
                                                </div>
                                                {this.olderThan(percents, type, true)}
                                            </div>
                                        )
                                    }
                                })}
                                <div style={{ ...style3.formButtonContainer }}>
                                    <button disabled={loadingRates} style={{ ...style3.formButton, ...style3.pointer }}>
                                        {'שמירה'}
                                    </button>
                                    {loadingRates ? <Spin /> : ''}
                                </div>
                            </form>
                        )}
                    </div>
                </div>

                <div style={{ margin: '0 80px 0 0' }}>
                    <div style={{ ...style3.title, padding: '0 20px 0 0' }}>
                        {!editMonths &&
                            (roles.includes('admin') ||
                                roles.includes('money') ||
                                roles.includes('agents_moderator')) && (
                                <span
                                    style={{ ...style3.pointer, height: '23px' }}
                                    onClick={() => this.setState({ editMonths: true })}
                                >
                                    {'עריכה'}
                                </span>
                            )}
                        {editMonths && (
                            <div>
                                <button
                                    disabled={loadingMonth}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', paddingRight: '0' }}
                                    onClick={() => this.setState({ editMonths: false })}
                                >
                                    {'ביטול'}
                                </button>
                                <button
                                    disabled={loadingMonth}
                                    onClick={this.submitMonth}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                >
                                    {' '}
                                    {'שמירה'}{' '}
                                </button>
                                {loadingMonth ? <Spin /> : ''}
                            </div>
                        )}
                    </div>
                    <div style={{ ...style3.inAdvanceWrapper }}>
                        {!editMonths && (
                            <div style={{ ...style3.unit }}>
                                <h6>{'חודשי עמלה ראשונית'}</h6>
                                <span style={{ display: 'inline-block', height: '32px' }}>
                                    {agentInfo.advanced_commission}
                                </span>
                            </div>
                        )}
                        {editMonths && (
                            <div style={{ ...style3.formUnit, display: 'flex', flexDirection: 'column' }}>
                                <h6>{'חודשי עמלה ראשונית'}</h6>
                                <Select
                                    style={{
                                        alignSelf: 'stretch'
                                    }}
                                    onChange={this.handleMonthSelect}
                                    defaultValue={agentInfo.advanced_commission}
                                    disabled={loadingMonth}
                                    value={advanced_commission}
                                >
                                    {Array(13)
                                        .fill(null)
                                        .map((_, idx) => (
                                            <Select.Option value={idx} key={idx.toString()}>
                                                {idx}
                                            </Select.Option>
                                        ))}
                                </Select>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const style3 = {
    title: { display: 'flex', justifyContent: 'space-between', padding: '0 20px 0 0' },
    body: { display: 'flex', justifyContent: 'start' },
    line: { marginBottom: '6px' },
    form: { display: 'flex', flexWrap: 'wrap', justifyContent: 'start', height: '100%', position: 'relative' },
    unit: { marginInline: '20px', marginTop: '20px' },
    formUnit: { marginInline: '20px', marginTop: '20px' },
    inputWrapper: { display: 'flex', justifyContent: 'space-between' },
    formButton: { background: 'none', border: 'none' },
    formButtonContainer: { position: 'absolute', top: '-22px', right: '60px' },
    editableRate: { display: 'flex' },
    column: { display: 'flex', flexDirection: 'column' },
    pointer: { cursor: 'pointer' },
    inAdvanceWrapper: {}
}
